export * from 'inpc/actions/inpc_actions';



// WEBPACK FOOTER //
// src/modules/secured/modules/inpc/actions/index.js